export const LOGIN_INVALID_CRDENTIALS_ERROR = `Please Enter Valid Credentials.`;
export const SOMETHING_WENT_WRONG = `Something Went Wrong.`;
export const LOGIN_CRDENDTIALS_NOT_FOUND = `Please Enter Login Crdentials.`


// WEBPACK FOOTER //
// ./src/app/appConstant.ts